// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card-title {
  --color: white;
}

ion-card {
  --background: var(--dark-blue-bg);
  --color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/customer-and-address-card/customer-and-address-card.component.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/components/customer-and-address-card/customer-and-address-card.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;ACCJ;;ADEA;EACI,iCAAA;EACA,cAAA;ACCJ","sourcesContent":["ion-card-title {\r\n    --color: white;\r\n}\r\n\r\nion-card {\r\n    --background: var(--dark-blue-bg);\r\n    --color: white;\r\n}\r\n","ion-card-title {\n  --color: white;\n}\n\nion-card {\n  --background: var(--dark-blue-bg);\n  --color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
